export default {
  props: {
    title: String,
    content: String,
    isOpen: {
      type: Boolean,
      default: false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    darkHeader: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: 'default',
    },
    accordion: {
      default: null,
    },
    id: {
      default: null,
    },
    canClose: {
      type: Boolean,
      default: true,
    },
    showChevron: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isOpenState: this.isOpen,
    };
  },
  computed: {
    hasSlotTitle() {
      return !!this.$slots.title;
    },
    hasSlotContent() {
      return !!this.$slots.default;
    },
    wrapperModifier() {
      if (this.id !== null) {
        this.isOpenState = (this.accordion === this.id);
      }
      return {
        'collapsible-panel--no-chevron': !this.showChevron,
        'collapsible-panel--is-open': this.isOpenState,
        [`collapsible-panel--theme-${this.theme}`]: true,
      };
    },
    noPaddingModifier() {
      return {
        'collapsible-panel--no-padding': this.noPadding,
      };
    },
    darkHeaderModifier() {
      return {
        'collapsible-panel--dark-header': this.darkHeader,
      };
    },
  },
  methods: {
    toggle() {
      if (this.isOpenState === true && !this.canClose) return;

      this.isOpenState = !this.isOpenState;
      if (this.id !== null) {
        this.$emit('open', this.isOpenState ? this.id : null);
      } else {
        this.$emit('toggle', this.isOpenState);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/collapsible-panel/collapsible-panel.js